import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexECA() {
  return (
    <div>
         <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

         <iframe
      src="/SelexECA/index.html"
      width="100%"
      height="750px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexECA